// extracted by mini-css-extract-plugin
export var algoliaSearchBox = "styles-module__algoliaSearchBox___Ir091";
export var birthdayContainer = "styles-module__birthdayContainer___oVNpN";
export var birthdayLabel = "styles-module__birthdayLabel___N6LTC";
export var calorieContainer = "styles-module__calorieContainer___tFs4I";
export var calorieSection = "styles-module__calorieSection___yDDV8";
export var flexRow = "styles-module__flexRow___uFYUv";